import React from 'react'

const Nav = () => {
  return (
    <nav />
  )
}

export default Nav
